import { HttpParams } from '@angular/common/http';
import { toListQueryParams } from '@doctor-scheduling/shared/utils';
import { PaginatedQueryOptions } from '@doctor-scheduling/shared/models';

/** Builds Angular HttpParams from an Eaze-style list query. */
export function buildListHttpParams(
  opts?: PaginatedQueryOptions | Record<string, unknown> | null
): HttpParams {
  const flat = toListQueryParams((opts ?? {}) as Record<string, unknown>);
  let params = new HttpParams();
  for (const [key, value] of Object.entries(flat)) {
    params = params.set(key, value);
  }
  return params;
}
